import React, { useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// @mui material components
import TableContainer from "@mui/material/TableContainer";
import Icon from "@mui/material/Icon";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { useAuth } from "context";
import MDBadge from "components/MDBadge";
import { CASHBACK_STATUS_COLOR } from "core/constant";
import { RESTAURANT_LEVEL_HEX_COLOR } from "core/constant";
function OrderHistoryMobile({ orderDataForMobile }) {
  const [openModal, setOpenModal] = useState(null);
  const { darkMode } = useAuth();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: !darkMode ? "background.paper" : "#202940",
    boxShadow: 10,
    p: 4,
    borderRadius: 2,
    "@media (max-width:767px)": {
      width: "95%",
      padding: `32px 8px`,
    },
  };

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      <MDBox>
        {orderDataForMobile?.map((data, index) => {
          return (
            <React.Fragment key={index}>
              <MDBox
                sx={{ p: 2, borderBottom: "1px solid gray", cursor: "pointer" }}
                onClick={() => setOpenModal(data.id)}
              >
                <MDBox
                  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDTypography sx={{ fontWeight: "500" }}>#{data.orderId}</MDTypography>
                  <MDTypography sx={{ fontSize: "16px" }}>{data.deliveredDate || "-"}</MDTypography>
                </MDBox>
                <MDBox
                  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDBox sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                    <MDTypography sx={{ fontSize: "16px" }}>{data.pointEarned || 0}</MDTypography>
                  </MDBox>
                  <MDTypography sx={{ fontSize: "16px" }}>
                    <MDBadge
                      badgeContent={data?.status}
                      color={CASHBACK_STATUS_COLOR[data?.cashbackStatus]}
                      variant="gradient"
                      size="lg"
                    />
                  </MDTypography>
                </MDBox>
              </MDBox>
              <Modal
                open={openModal === data.id}
                onClose={() => setOpenModal(null)}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >
                <Box sx={style}>
                  <card>
                    <MDBox
                      pt={1}
                      px={1}
                      sx={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }}
                    >
                      <MDTypography sx={{ fontSize: "15px" }}>RESTAURANT NAME</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.restaurantName || "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>ORDER ID</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.orderId}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>DELIVERED DATE</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.deliveredDate || "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>ORDER TIER</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {/* {data.orderTier} */}
                        <MDBox
                          sx={{
                            backgroundColor: RESTAURANT_LEVEL_HEX_COLOR[data?.orderTier],
                            borderRadius: "4px",
                            padding: "5px",
                            position: "relative",
                          }}
                        >
                          <MDBox
                            sx={{
                              color: "#FFFFFF",
                              fontSize: "12px",
                              fontWeight: 400,
                              lineHeight: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 1,
                            }}
                          >
                            {data?.orderTier}
                          </MDBox>
                        </MDBox>
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>ORDER AMOUNT</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.orderAmount}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>POINTS EARNED</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        {data.pointEarned || 0}
                      </MDTypography>
                    </MDBox>
                    <MDBox pt={1} px={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                      <MDTypography sx={{ fontSize: "15px" }}>CASHBACK STATUS</MDTypography>
                      <MDTypography sx={{ textAlign: "end", fontSize: "15px" }}>
                        <MDBox ml={-1}>
                          <MDBadge
                            badgeContent={data?.status}
                            color={CASHBACK_STATUS_COLOR[data?.cashbackStatus]}
                            variant="gradient"
                            size="lg"
                          />
                        </MDBox>
                      </MDTypography>
                    </MDBox>
                  </card>
                </Box>
              </Modal>
            </React.Fragment>
          );
        })}
      </MDBox>
    </TableContainer>
  );
}

// Typechecking props for the OrderHistoryMobile
OrderHistoryMobile.propTypes = {
  orderDataForMobile: PropTypes.any,
};

export default OrderHistoryMobile;
